import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledItem = styled.div<{
  $isDragging: boolean;
  $isDragDisabled: boolean;
  $isNew: boolean;
  $isEditable: boolean;
  $type: string;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 0 16px 0 16px;
  width: 300px;
  margin-right: ${(props) => (props.$type === "grade" ? "0px" : "16px")};
  height: 50px;
  cursor: ${(props) => (props.$isEditable ? "pointer" : "default")};
  pointer-events: ${(props) => (props.$isDragDisabled ? "none" : "auto")};
  margin-bottom: 8px;
  border-radius: ${theme.variables.border_radius_1};
  border: ${(props) =>
    props.$isNew && props.$isEditable
      ? `1px dotted ${theme.colors.purple}`
      : `1px solid ${theme.colors.trasparent}`};
  background-color: ${(props) =>
    props.$isDragging ? theme.colors.purple_2 : theme.colors.purple_5};
  justify-content: ${(props) => (props.$isEditable ? "space-between" : "")};

  &:hover {
    background-color: ${(props) =>
      props.$isEditable ? theme.colors.purple_2 : ""};
    border: ${(props) =>
      props.$isEditable ? `1px solid ${theme.colors.purple}` : ""};

    & > div:last-child {
      visibility: ${(props) =>
        props.$isEditable || props.$isNew ? "visible" : "hidden"};
    }
  }

  & > div {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;

    & > span > span {
      width: 160px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      text-align: left;
    }
  }

  & > div:last-child {
    visibility: ${(props) => (props.$isNew ? "visible" : "hidden")};

    & > div {
      cursor: pointer;
    }
  }
`;

export const CheckIconContainer = styled.div<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.$isActive ? theme.colors.purple : "transparent"};
  cursor: ${(props) => (props.$isActive ? "pointer" : "default")};
  transition:
    background-color 0.3s ease,
    color 0.3s ease;
`;

export const StyledCloseIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: transparent;
  cursor: pointer;
`;
